import { Button, FormControl, FormHelperText, FormLabel, Input, Stack } from '@mui/material';
import { useForm } from 'react-hook-form';

interface PasswordResetFormProps {
  onSubmit: (username: string, password: string) => void;
  username?: string | null;
  disabledSubmit?: boolean;
}

interface PasswordResetFormValues {
  password: string;
  password_repeat: string;
}

export function PasswordResetForm(props: PasswordResetFormProps) {
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm<PasswordResetFormValues>();

  const onSubmit = (data: PasswordResetFormValues) => {
    props.onSubmit(props.username ?? '', data.password);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <input type="hidden" name="username" autoComplete="username" value={props.username ?? undefined} />
      <Stack spacing={2} sx={{ mb: 2 }}>
        <FormControl required error={!!errors.password}>
          <FormLabel>Heslo</FormLabel>
          <Input
            type="password"
            autoComplete="new-password"
            {...register('password', {
              required: 'Heslo je povinné',
              minLength: { value: 8, message: 'Heslo musí mať aspoň 8 znakov' },
            })}
          />
          {errors.password && <FormHelperText>{errors.password.message}</FormHelperText>}
        </FormControl>

        <FormControl required error={!!errors.password_repeat}>
          <FormLabel>Zopakuj heslo</FormLabel>
          <Input
            type="password"
            autoComplete="new-password"
            {...register('password_repeat', {
              required: 'Potvrdenie hesla je povinné',
              validate: (value) => value === getValues('password') || 'Heslá sa nezhodujú',
            })}
          />
          {errors.password_repeat && <FormHelperText>{errors.password_repeat.message}</FormHelperText>}
        </FormControl>
      </Stack>

      <Button type="submit" fullWidth variant="contained" disabled={props.disabledSubmit}>
        Obnov heslo
      </Button>
    </form>
  );
}
